// src/components/store/sections/blog-posts/BlogV86CathedralarchRoyalViolet.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV86CathedralarchRoyalViolet(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={86}
      archKey="cathedral_arch"
      archLabel="Cathedral Arch Articles"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
